import * as types from '../types/visitorTypes';

export const setVisitorCountry = (payload) => (dispatch) => {
  dispatch({ type: types.SET_VISITOR_COUNTRY, payload });
};

export const setVisitorId = (id) => ({ type: types.CREATE_VISITOR_SUCCESS, payload: { _id: id } });
